/**
 * Training model translations
 *
 * Translation keys follow the pattern: models.training.{category}.{key}
 * Categories: fields, tabs, blocks, badges, filters
 */
export default {
  en: {
    singular: "Training",
    plural: "Trainings",

    fields: {
      title: "Title",
      description: "Description",
      duration: "Duration (seconds)",
      is_required: "Required",
    },

    tabs: {
      main: "Details",
      media: "Media",
    },

    blocks: {
      details: "Details",
      videos: "Videos",
      thumbnails: "Thumbnails",
    },

    badges: {
      true: "Required",
      false: "Optional",
    },

    filters: {
      is_required: "Required",
    },
  },

  fr: {
    singular: "Formation",
    plural: "Formations",

    fields: {
      title: "Titre",
      description: "Description",
      duration: "Durée (secondes)",
      is_required: "Obligatoire",
    },

    tabs: {
      main: "Détails",
      media: "Médias",
    },

    blocks: {
      details: "Détails",
      videos: "Vidéos",
      thumbnails: "Miniatures",
    },

    badges: {
      true: "Obligatoire",
      false: "Optionnel",
    },

    filters: {
      is_required: "Obligatoire",
    },
  },
};
